import { Link, useSearchParams } from 'react-router-dom';
import { ShieldAlert, Zap } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function Unauthorized() {
    const [searchParams] = useSearchParams();
    const { user, logout } = useAuth();
    const reason = searchParams.get('reason');
    const feature = searchParams.get('feature');

    const isPlanRestricted = reason === 'plan_restricted';
    const canUpgrade = user && (user.role === 'admin' || user.role === 'owner');

    const handleBackToHome = () => {
        logout();
    };

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center space-y-6">
                <div className="flex justify-center">
                    <div className={`p-4 rounded-full ${isPlanRestricted ? 'bg-amber-100 text-amber-600' : 'bg-red-100 text-red-600'}`}>
                        {isPlanRestricted ? <Zap className="w-16 h-16" /> : <ShieldAlert className="w-16 h-16" />}
                    </div>
                </div>
                <h1 className="text-3xl font-bold text-gray-900">
                    {isPlanRestricted 
                        ? (canUpgrade ? 'Upgrade Your Plan' : 'Plan Upgrade Required') 
                        : 'Access Denied'}
                </h1>
                <p className="text-gray-600 text-lg">
                    {isPlanRestricted 
                        ? `The ${feature === 'kitchen' ? 'Kitchen Display System (KDS)' : 'Delivery Management System'} is not available on your current plan. ${canUpgrade ? 'Please upgrade to access this feature.' : 'Please contact your store administrator to upgrade the subscription.'}`
                        : 'Action not allowed for your role. You do not have permission to access this page.'}
                </p>
                <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center items-center">
                    <Link
                        to="/"
                        onClick={handleBackToHome}
                        className="btn-primary px-8 py-3 inline-block"
                    >
                        Back to Home
                    </Link>
                    {isPlanRestricted && canUpgrade && (
                        <a
                            href="/admin/settings"
                            className="bg-slate-900 text-white font-bold px-8 py-3 rounded-xl hover:bg-slate-800 transition-colors inline-block"
                        >
                            Upgrade Plan
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
